
import React, { Component } from 'react';
import './Premium.scss';

class Premium extends Component {  
    // constructor(props){
    //     super(props);
    // }
    render(){
        // width={this.props.width} height={this.props.height}
        return(
            <svg  className="premium" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 201 50" enableBackground="new 0 0 201 50" space="preserve">
                <polygon fill="currentColor" points="1.145,0.324 1.145,0.859 38.289,25.098 1.145,49.337 1.145,49.676 199.854,49.676 199.854,0.324 "/>
                <g>

                    <clipPath id="VTN_PREMIUM_SVGID_2_">
                        <rect id="VTN_PREMIUM_SVGID_1_" width="201" height="50"/>
                    </clipPath>
                    <path clipPath="url(#VTN_PREMIUM_SVGID_2_)" fill="#FFFFFF" d="M68.404,21.589c0,4.498-3.26,7.214-8.633,7.214h-5.675v6.671h-2.234V14.344
                        h7.909C65.145,14.344,68.404,17.061,68.404,21.589 M66.17,21.589c0-3.381-2.234-5.313-6.46-5.313h-5.614v10.565h5.614
                        C63.937,26.841,66.17,24.909,66.17,21.589"/>
                    <path clipPath="url(#VTN_PREMIUM_SVGID_2_)" fill="#FFFFFF" d="M85.248,35.474l-4.83-6.791c-0.543,0.061-1.087,0.091-1.69,0.091h-5.675v6.7
                        h-2.234V14.344h7.909c5.373,0,8.633,2.717,8.633,7.245c0,3.32-1.751,5.646-4.83,6.642l5.162,7.243H85.248z M85.126,21.589
                        c0-3.381-2.234-5.313-6.46-5.313h-5.614v10.595h5.614C82.893,26.871,85.126,24.909,85.126,21.589"/>
                    <polygon clipPath="url(#VTN_PREMIUM_SVGID_2_)" fill="#FFFFFF" points="105.17,33.543 105.17,35.475 90.228,35.475 90.228,14.345 
                        104.717,14.345 104.717,16.276 92.461,16.276 92.461,23.792 103.389,23.792 103.389,25.694 92.461,25.694 92.461,33.543 	"/>
                    <polygon clipPath="url(#VTN_PREMIUM_SVGID_2_)" fill="#FFFFFF" points="129.952,14.345 129.952,35.475 127.809,35.475 127.809,18.57 
                        119.508,32.787 118.451,32.787 110.149,18.661 110.149,35.475 108.007,35.475 108.007,14.345 109.848,14.345 119.024,30.011 
                        128.11,14.345 	"/>
                    <rect x="134.419" y="14.345" clipPath="url(#VTN_PREMIUM_SVGID_2_)" fill="#FFFFFF" width="2.234" height="21.129"/>
                    <path clipPath="url(#VTN_PREMIUM_SVGID_2_)" fill="#FFFFFF" d="M140.938,26.449V14.345h2.234v12.013c0,5.012,2.354,7.306,6.459,7.306
                        c4.136,0,6.489-2.294,6.489-7.306V14.345h2.174v12.104c0,6.066-3.26,9.207-8.663,9.207S140.938,32.516,140.938,26.449"/>
                    <polygon clipPath="url(#VTN_PREMIUM_SVGID_2_)" fill="#FFFFFF" points="184.557,14.345 184.557,35.475 182.413,35.475 182.413,18.57 
                        174.112,32.787 173.056,32.787 164.754,18.661 164.754,35.475 162.611,35.475 162.611,14.345 164.452,14.345 173.629,30.011 
                        182.715,14.345 	"/>
                </g>
            </svg>
        );
    }
}

export default Premium;

